import { render, staticRenderFns } from "./NgColor.vue?vue&type=template&id=5e98cdfd"
import script from "./NgColor.vue?vue&type=script&lang=js"
export * from "./NgColor.vue?vue&type=script&lang=js"
import style0 from "./NgColor.vue?vue&type=style&index=0&id=5e98cdfd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports